<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="800px"
    @close="handleClose"
  >
    <el-form :model="formObj" ref="formRef" label-width="110px">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="分公司">
            <el-select
              v-model="formObj.branchCode"
              size="small"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in orgList"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="维度">
            <el-select
              v-model="formObj.dimensionCode"
              size="small"
              placeholder="请选择"
              @change="changeDimensionCode"
            >
              <el-option
                v-for="(item, index) in dimensionList"
                :key="index"
                :label="item.enumName"
                :value="item.enumCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="占比">
            <el-input
              v-model="formObj.ratio"
              size="small"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="14">
          <el-form-item label="引用分公司数据">
            <el-select
              v-model="formObj.usebranchCode"
              size="small"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in orgList"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
            <el-button :disabled="sowCopyBth(formObj)" style="margin-left: 20px" type="primary"  size="small" @click="sureCopy">确定引用</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="table-box">
      <div class="table-header">
        <div>取值范围</div>
        <div v-if="formObj.dimensionCode == '1' || formObj.dimensionCode == '2'">
          <el-button type="primary" size="mini" @click="addRow">新增</el-button>
        </div>
      </div>
      <div>
        <el-table
          :data="tableData"
          v-show="formObj.dimensionCode == '1' || formObj.dimensionCode == '2' 
                    || formObj.dimensionCode == '3' || formObj.dimensionCode == '4'
                    || formObj.dimensionCode == '5' || formObj.dimensionCode == '6'"
          border
          style="width: 100%"
        >
          <el-table-column
            align="center"
            type="index"
            label="序号"
            width="50"
          >
          </el-table-column>
          <template v-if="formObj.dimensionCode == '1' || formObj.dimensionCode == '2'">
            <el-table-column
              align="center"
              prop="rangeStart"
              show-overflow-tooltip
              label="开始"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-if="scope.row.isEditing"
                  controls-position="right"
                  :min="0"
                  :max="100"
                  v-model="scope.row.rangeStart"
                  size="mini"
                ></el-input-number>
                <span v-else>{{ scope.row.rangeStart }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="rangeEnd"
              show-overflow-tooltip
              label="结束"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-if="scope.row.isEditing"
                  controls-position="right"
                  :min="0"
                  :max="100"
                  v-model="scope.row.rangeEnd"
                  size="mini"
                ></el-input-number>
                <span v-else>{{ scope.row.rangeEnd }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
              align="center"
              prop="dimensionVal"
              show-overflow-tooltip
              label="值"
            >
              <template slot-scope="scope">
                {{ setDimensionVal(scope.row.dimensionVal, formObj.dimensionCode ) }}
              </template>
            </el-table-column>
          </template>
          <el-table-column
            align="center"
            prop="score"
            show-overflow-tooltip
            label="分值"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="scope.row.isEditing"
                controls-position="right"
                :min="0"
                :max="100"
                v-model="scope.row.score"
                size="mini"
              ></el-input-number>
              <span v-else>{{ scope.row.score }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="180" label="操作">
            <template slot-scope="scope">
              <span v-if="!scope.row.isEditing">
                <el-button type="text" @click="editRow(scope.row)">修改</el-button>
                <el-button v-if="formObj.dimensionCode == '1' || formObj.dimensionCode == '2'" type="text" style="color: gray" @click="deleteRow(scope.row)">删除</el-button>
              </span>
              <span v-else>
                <el-button type="text" @click="saveRow(scope.row,formObj.dimensionCode)">保存</el-button>
                <el-button type="text" style="color: gray" @click="cancelEdit(scope.row)">取消</el-button>
              </span>
            </template>
          </el-table-column>
      </el-table>
      </div>
    </div>
    <div class="btns">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submitForm">确定</el-button>
    </div>
  </el-dialog>
</template>
   
<script>
import url from "@/modules/url";
import api from "@/modules/api";

import { Options } from '@/components/utils/fixOptions'
export default {
  data() {
    return {
      dimensionValList: [],
      sexList: Options.familySex,
      maritalStatus: Options.marital_status,
      education: Options.education,
      insureHistory: Options.insure_history,
      tableData: [],
      dimensionList: this.wdList.slice(1),
      showTable: false,
      dialogVisible: true, // 控制对话框的显示与隐藏
      cascaderProps: {
        multiple: true,
        value: "code", // 指定 value 字段
        label: "name", // 指定 label 字段
        children: "childList", // 指定 children 字段
      },
      formObj: {
        branchCode: "", // 机构编码
        dimensionCode: "", // 维度
        ratio: "", // 占比
        usebranchCode: "", //引用分公司数据
        copyOtherBranch: false
      },
      manageComNameOptions: [], // 存储机构下拉菜单数据的集合
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now(); // 禁用今天之前的日期
        },
      },
    };
  },
  props: {
    title: {
      type: String,
      default: "新增",
    },
    formData: {
      type: [Array],
      default: "",
    },
    orgList: {
      type: Array,
      default: [],
    },
    wdList: {
      type: Array,
      default: [],
    },
  },
  mounted() {
    if(this.formData.length > 0) {
      console.log("----------------> init")
      const { branchCode, dimensionCode, ratio } = this.formData[0]
      this.getLabelList(dimensionCode)
      this.formObj = {
        branchCode: branchCode,
        dimensionCode: dimensionCode,
        ratio: ratio,
        usebranchCode: "", //引用分公司数据  dimensionCode == '1' || dimensionCode == '2'
        copyOtherBranch: false
      }
      this.tableData = []
      this.formData.forEach(ele=> {
        if(ele.dimensionCode == '1' || ele.dimensionCode == '2') {
          this.tableData.push({
            id: ele.id,
            rangeStart: ele.rangeStart,
            rangeEnd: ele.rangeEnd,
            score: ele.score,
            isEditing: false,
            oldData: {}
          })
        }else{
          this.tableData.push({
            id: ele.id,
            dimensionVal: ele.val,
            score: ele.score,
            isEditing: false,
            oldData: {}
          })
        }
      });
      console.log(this.formObj, this.tableData,"editData=====");
    }else{
      this.changeDimensionCode(dimensionCode)
    }
  },
  methods: {
    sowCopyBth(obj){
      if(obj.usebranchCode) {
        return false
      } else {
        return true
      }
    },
    setDimensionVal(val,weidu){
      if(weidu == '3') {
        return this.sexList.find(ite => ite.value == val).label
      }else if(weidu == 4) {
        return this.maritalStatus.find(ite => ite.value == val).label
      }else if(weidu == '5') {
        return this.education.find(ite => ite.value == val).label
      }else if(weidu == '6') {
        return this.insureHistory.find(ite => ite.value == val).label
      }
    },
    getLabelList(val){
      if(val == '3') {
        this.dimensionValList = this.sexList
      } else if(val == '4') {
        this.dimensionValList = this.maritalStatus
      } else if (val == '5') {
        this.dimensionValList = this.education
      } else if (val == '6') {
        this.dimensionValList = this.insureHistory
      }
    },
    changeDimensionCode(val){
      this.getLabelList(val)
      if(val == '3' || val == '4' || val == '5' || val == '6') {
        let tableList = []
        this.dimensionValList.forEach(item=>{
          tableList.push({
            dimensionVal: item.value,
            score: "",
            isEditing: true,
            oldData: {}
          });
        })
        this.tableData = tableList
      }
    },
    sureCopy(){
      const {usebranchCode,dimensionCode} = this.formObj
      if(usebranchCode && dimensionCode) {
        api.post(url.copyByBranchAndDimension, { branchCode: usebranchCode,dimensionCode:dimensionCode }, (res) => {
          if (res.result.isSuccess) {
            if(res.data.length) {
              this.$confirm('如果引用该数据，则下方已维护的数据（如有）将情况，确认引用么?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
              }).then(() => {
                let list = []
                this.$set(this.formObj, "ratio",  res.data[0].ratio);
                res.data.forEach(ele=> {
                  if(dimensionCode == '1' || dimensionCode == '2') {
                    list.push({
                      rangeStart: ele.rangeStart,
                      rangeEnd: ele.rangeEnd,
                      score: ele.score,
                      isEditing: false,
                      oldData: {}
                    })
                  }else {
                    list.push({
                      dimensionVal: ele.value,
                      score: ele.score,
                      isEditing: false,
                      oldData: {}
                    });
                  }
                })
                this.tableData = list
                this.$set(this.formObj, "copyOtherBranch", true);
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });          
              });
            }else{
              this.$message({
                type: 'info',
                message: '所选机构还未维护该维度数据，请重新选择。'
              });
            }
          } else {
            let msg = res.result.errors.length > 0 ? res.result.errors[0].errorCode + res.result.errors[0].error : res.result.error;
            this.$message({
              type: 'error',
              message: msg
            }); 
          }
        });
      } else {
        this.$message.error("请选择维度和引用分公司数据");
      }
      return
    },
    // 新增行
    addRow() {
      this.tableData.push({
        rangeStart: "",
        rangeEnd: "",
        score: "",
        isEditing: true,
        oldData: {}
      });
    },
    // 编辑行
    editRow(row) {
      row.oldData = { ...row }; // 备份数据
      row.isEditing = true;
    },
    validateRow(row, dimensionCode) {
      console.log(row, dimensionCode, "------->row");
      if(dimensionCode=='1' || dimensionCode == '2') {
        if ((row.rangeStart == null || row.rangeStart === '') || 
          (row.rangeEnd == null || row.rangeEnd === '') || 
          (row.score == null || row.score === '')) {
          this.$message.error("所有字段均不能为空，请完善之后再保存");
          return false;
        }

        if (parseInt(row.rangeStart) >= parseInt(row.rangeEnd)) {
          this.$message.error("结束值必须大于开始值");
          return false;
        }

        let isValid = true;
        this.tableData.forEach(r => {
          if (r !== row && r.rangeStart && r.rangeEnd) {
            if (
              parseInt(row.rangeStart) < parseInt(r.rangeEnd) &&
              parseInt(row.rangeEnd) > parseInt(r.rangeStart)
            ) {
              isValid = false;
            }
          }
        });

        if (!isValid) {
          this.$message.error("年龄段有交集，请重新输入");
          return false;
        }
        return true;
      }
      else if(dimensionCode=='3' || dimensionCode == '4' 
        || dimensionCode == '5' || dimensionCode == '6') {
        // if(!row.dimensionVal){
        //   this.$message.error("所有字段均不能为空，请完善之后再保存");
        //   return false;
        // }
        return true;
      } 
    },
    // 保存行
    saveRow(row,dimensionCode) {
      if (this.validateRow(row,dimensionCode)) {
        row.isEditing = false;
        row.oldData = {}; // 清空备份
      }
    },
    // 删除行
    deleteRow(row) {
      this.$confirm('确定要删除该维度信息？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableData = this.tableData.filter(item => item !== row);
      });
    },
    // 取消编辑
    cancelEdit(row) {
      Object.assign(row, row.oldData); // 还原数据
      row.isEditing = false;
      row.oldData = {};
    },
    // 提交表单
    submitForm() {
      const { branchCode, dimensionCode, ratio,copyOtherBranch} = this.formObj
      if(!branchCode || !dimensionCode || [null, undefined, ''].includes(ratio)) {
        this.$message.error("所有字段均不能为空，请完善之后再保存");
        return
      }
      if (!/^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/.test(ratio)) {
        this.$message.error("分值占比必须在1到100之间，最多两位小数");
        return
      }
      const dimensionName = this.dimensionList.find(ite=>ite.enumCode == dimensionCode).enumName
      const data = {
        branchCode: branchCode,
        dimensionCode: dimensionCode,
        dimensionName: dimensionName,
        ratio: ratio,
        enumItemProperty: dimensionCode == '1' || dimensionCode == '2' ? 'RANGE' :  'VAL',
        rangeAndScoreList: this.tableData,
        copyOtherBranch: copyOtherBranch
      }
      if(!data.rangeAndScoreList.length) {
        this.$message.error("取值范围不能为空");
        return
      }
      for (let row of data.rangeAndScoreList) {
        row.isEditing = false
        row.oldData={}
        if (!this.validateRow(row,dimensionCode)) {
          return; // 发现错误就终止
        }
      }
      this.save(data);
    },
    save(data) {
      api.post(url.saveAccountProfile, data, (res) => {
        if (res.result.isSuccess) {
          this.handleClose('refresh');
          console.log(res.result, "提交成功");
        } else {
          let msg = res.result.errors.length > 0 ? res.result.errors[0].error : res.result.error;
          this.$message({
            type: 'error',
            message: msg
          }); 
        }
      });
    },
    handleClose(flag='') {
      this.formObj = {
        branchCode: "",
        dimensionCode: "",
        ratio: "",
        usebranchCode: "",
        enumItemProperty: false
      };
      this.tableData = []
      this.$emit("close");
      flag == 'refresh' && this.$emit('refresh')
    }
  },
};
</script>
  
<style lang="scss" scoped>
.table-box {
  margin-bottom: 20px;
  padding: 0px 10px 0 45px;
  .table-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
.btns {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/recruit/candidatePortrait/component/editPortrait.vue